// src/runtime/internal/inject-react/index.ts
import * as React from "react";
export {
  React
};
